var bookshelf = require("../index-extended");
require("./Mandate");
require("./Building");

module.exports = bookshelf.model("Contact", {
  entityName: "Contact",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "contact",
  building() {
    return this.belongsTo("Building");
  },
});
